import React, { useState, useEffect, useCallback, useRef } from "react";
// import * as enquirySelectors from "../../../../../common/selectors/enquiry";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import moment from "moment";
import Divider from "@material-ui/core/Divider";
import CustomText, {
  getFontSize,
  getFontWeight,
} from "../../../../components/CustomText";
import CustomPaper from "../../../../components/CustomPaper";
import _ from "lodash";
import Image from "../../../../../assets";
import { connect } from "react-redux";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import { withRouter } from "react-router-dom";
import Color from "../../../../../utils/Color";
import useMediaQuery from "@material-ui/core/useMediaQuery";

const useStyles = makeStyles((theme) => ({
  spacing: {
    paddingLeft: "0.7em",
  },
  buttonStyle: {
    backgroundColor: "transparent",
    color: Color.primaryTextColor,
    textTransform: "none",
    width: "96px",
    height: "35px",
    border: "1px solid",
    borderRadius: "5px",
    marginTop: "-3em",
    "&:focus": {
      backgroundColor: Color.primaryTextColor,
      color: "white",
      outline: "none",
    },
    "&:hover": {
      color: "white",
      backgroundColor: "Color.primaryTextColor",
    },
  },
  chatBgC: {
    backgroundColor: "#FFFFFF",
    paddingTop: 10,
    paddingBottom: 15,
    paddingLeft: 20,
    paddingRight: 20,
    boxShadow: "0px 0px 6px #00000033",
    borderRadius: "0px 15px 15px 15px",
  },
  chatBgUsr: {
    backgroundColor: "#00B4AF",
    color: "#FFFFFF",
    paddingTop: 10,
    paddingBottom: 15,
    paddingLeft: 20,
    paddingRight: 20,
    boxShadow: "0px 0px 6px #00000033",
    borderRadius: "0px 15px 15px 15px",
  },
  usrName: {
    color: Color.blueButtonColor,
    textAlign: "left",
  },
  usrMsg: {
    textAlign: "left",
    ...getFontWeight("600"),
    paddingTop: 8,
    color: "#424143",
    paddingBottom: 8,
  },
  adMsg: {
    textAlign: "right",
    ...getFontWeight("600"),
    paddingTop: 8,
    paddingBottom: 8,
    backgroundColor: "#00B4AF",
    color: "#FFFFFF",
  },
  adName: {
    color: Color.blueButtonColor,
    textAlign: "right",
  },
  usrtimeMsg: {
    opacity: 0.6,
    ...getFontSize("xsmall"),
    ...getFontWeight("normal"),
    textAlign: "right",
    marginTop: 18,
  },
  adtimeMsg: {
    opacity: 0.6,
    ...getFontSize("xsmall"),
    ...getFontWeight("normal"),
    textAlign: "left",
    marginTop: 18,
  },
  timeStyle: {
    marginTop: "-0.18em",
    paddingRight: "0.5em",
    paddingLeft: "0.5em",
    color: Color.primaryColor,
    // opacity: 0.6,
  },
  dividerStyle: {
    backgroundColor: Color.dividerColor,
  },
  listStyle: {
    width: "100%",
    //backgroundColor: theme.palette.background.paper,
    position: "relative",
    overflow: "scroll",
    maxHeight: window.innerHeight * 0.41,
    "&::-webkit-scrollbar": { width: "3px" },
    "&::-webkit-scrollbar-track": { background: "#fff" },
    "&::-webkit-scrollbar-thumb": { background: "#E0E0E0" },
  },
  sendButtonStyle: {
    height: 39,
    border: 0,
  },
  attachIconStyle: {
    color: Color.secondaryTextColor,
    width: 20,
    height: 20,
    cursor: "pointer",
  },
  displayUserImageStyle: {
    width: 40,
    height: 40,
    borderRadius: 5,
    border: "1px solid",
    borderColor: Color.textInputColor,
    boxShadow: "0 0 10px 0 rgba(18, 38, 63, 0.08)",
  },
  downloadStyle: {
    border: 0,
    padding: 0,
    " &:focus ": {
      outline: "none",
    },
  },
  docNameTextStyle: {
    color: Color.primaryColor,
    ...getFontSize("xsmall"),
    marginTop: 10,
    " &:hover ": {
      textDecoration: "underline",
      cursor: "pointer",
    },
  },
  imageLiveChatStyle: {
    width: 30,
    height: 30,
    marginRight: 15,
    //marginTop:-40
  },
  askQ: {
    color: "#00B4AF",
    marginTop: 5,
  },
  threeSelect: {
    border: "1px solid #00B4AF",
    borderRadius: "18px",
    padding: 10,
    //width: "50%",
    //height: "30px",
    textAlign: "center",
    lineHeight: "9px",
    marginRight: 20,
    color: "#00B4AF",
  },
}));

const MessageList = ({
  messageHistoryList,
  loginName,
  onClickFileAttached,
  handleBottomRef,
  scroll,
  createChatBtns,
  onClickSendMessage,
  sendLikeButton,
  localScrollDown,
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const matchesMD = useMediaQuery(theme.breakpoints.down("md"));
  const histList = messageHistoryList;
  // const histList = [];
  let filterDate = "";
  let displayDate = true;
  let newDate = new Date();
  const dateTime = moment(newDate, "DD/MM/YYYY hh:mm:ss a");
  const currentDate = moment(dateTime).format("DD/MM/YYYY");

  Array.isArray(histList) &&
    histList.map((item, index) => {
      // const itemDate = enquirySelectors.getHistListDate(item);
      // const name = enquirySelectors.getHistListName(item);
      // const message = enquirySelectors.getHistListDetails(item);
      // const type = enquirySelectors.getHistListType(item);
      // const docList = enquirySelectors.getDocList(item);
      // const dateTime = moment(itemDate, "MM/DD/YYYY hh:mm:ss a");
      // const date = moment(dateTime).format("DD/MM/YYYY");
      // const time = moment(dateTime).format("LT");

      const itemDate = "test";
      const name = "test";
      const message = "test";
      const type = "test";
      const docList = [];
      const dateTime = "test";
      const date = "test";
      const time = "test";
    });

  const ref = useRef();

  const messagesEndRef = useRef(null);

  const scrollToBottom = () => {
    if (scroll !== false && localScrollDown !== false) {
      !!messagesEndRef.current &&
        messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
      //messagesEndRef.current.scrollTo(999, 200);
    }
  };

  useEffect(scrollToBottom, [histList]);

  const addSpacingToKey = (key) => {
    // if(key === "NRIC" || key === "CKA Status"){
    //   return key;
    // }
    return key;
   // return key.replace(/([A-Z])/g, ' $1').trim();
  };

  return (
    <Grid container style={{ marginTop: 25 }} ref={ref}>
      <Grid item xs={12}>
        <List className={classes.listStyle}>
          {histList && Array.isArray(histList)
            ? histList.map((item, index) => {
                const sender = item.Sender;
                var content = item.Content;
                const messageType = item.MessageType;
                const isSystem = item.IsSystem;
                const isCustomer = item.IsCustomer;
                const imageUrl = item.ImageUrl;
                const createdDate = moment(
                  item.CreatedDate,
                  "MM/DD/YYYY hh:mm:ss a"
                );
                const date = moment(item.CreatedDate).format("DD/MM/YYYY");

                // const itemDate = "test";
                // const name = "test";
                // const message = "test";
                // const type = "test";
                const docList = [];
                // const dateTime ="test";
                // const date = "test";
                // const time = "test";

                // let date1 = ("0" + itemDate.getDate()).slice(-2);
                //console.log("itemDate",itemDate.getDate())

                {
                  /* if (filterDate === date) {
                  displayDate = false;
                } else {
                  displayDate = true;
                  filterDate = date;
                } */
                }
                // var a ;
                // if(messageType === 5){
                //   a = content.split("|")[0];
                // }

                // console.log("a",a);
                var a;
                var b;
                var c;
                if (messageType === 5) {
                  a = content.split("|")[1];
                  b = a.split("T")[0];

                  c = a.split("T")[1];
                }

                function urlify(text) {
                  if (text.includes("<a")) {
                    return text;
                  } else {
                    var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
                    //var urlRegex = /(https?:\/\/[^\s]+)/g;
                    return text.replace(urlRegex, function (url, b, c) {
                      var url2 = c == "www." ? "http://" + url : url;
                      return (
                        '<a href="' + url2 + '" target="_blank">' + url + "</a>"
                      );
                    });
                  }
                }

                content = content !== null ? urlify(content) : "";
                console.log(content);

                var contentSeven = "";
                var contentSevenNew = "";
                if (messageType === 7) {
                  contentSeven = JSON.parse(content);
                  //contentSevenNew = JSON.parse(contentSeven);
                  console.log("contentSeven", contentSeven);
                }
                return (
                  <div key={index}>
                    {displayDate ? (
                      <Grid container direction={"row"}>
                        {/* <Grid item xs={matchesMD ? 4 : 5}>
                          <Divider
                            className={classes.dividerStyle}
                            style={{ marginTop: 30 }}
                          />
                        </Grid>
                        <Grid item xs={matchesMD ? 4 : 3}>
                          <CustomText
                            style={{ textAlign: "center", marginTop: 20 }}
                          >
                            {date === currentDate
                              ? "Today"
                              : date.slice(0, 11)}{" "}
                            {date.slice(12, 22)}
                          </CustomText>
                        </Grid> */}
                        {/* <Grid item xs={4}>
                          <Divider
                            className={classes.dividerStyle}
                            style={{ marginTop: 30 }}
                          />
                        </Grid> */}
                      </Grid>
                    ) : (
                      false
                    )}

                    <div
                      style={{
                        paddingRight: 20,
                        paddingLeft: 20,
                        marginBottom: 40,
                      }}
                    >
                      <Grid
                        container
                        justify={!isCustomer ? "flex-start" : "flex-end"}
                        direction={"row"}
                        alignItems="center"
                        key={index}
                        style={{ flexWrap: "nowrap" }}
                      >
                        {!isCustomer ? (
                          imageUrl !== "" && imageUrl !== null ? (
                            <img
                              src={imageUrl}
                              className={classes.imageLiveChatStyle}
                            />
                          ) : (
                            <img
                              src={
                                !isSystem
                                  ? Image.maleAgent
                                  : Image.liveChatChatBot
                              }
                              className={classes.imageLiveChatStyle}
                            />
                          )
                        ) : scroll !== false ? (
                          <div ref={messagesEndRef} />
                        ) : (
                          false
                        )}

                        {messageType === 6 && (
                          <div
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            {messageType === 6
                              ? item.Cards.map((data, key) => {
                                  return (
                                    <CustomPaper
                                      key={key}
                                      design={
                                        !isCustomer
                                          ? classes.chatBgC
                                          : classes.chatBgUsr
                                      }
                                    >
                                      <img
                                        src={data.ImageUrl}
                                        style={{
                                          width: window.innerWidth * 0.4,
                                        }}
                                      />
                                      {console.log("data??", data)}
                                      <CustomText
                                        design={
                                          !isCustomer
                                            ? classes.usrMsg
                                            : classes.adMsg
                                        }
                                        style={{
                                          width: window.innerWidth * 0.4,
                                          whiteSpace: "pre-line",
                                        }}
                                        dangerouslySetInnerHTML={{
                                          __html: content,
                                        }}
                                      ></CustomText>
                                    </CustomPaper>
                                  );
                                })
                              : false}
                          </div>
                        )}

                        {messageType === 7 && (
                          <div
                            style={{ display: "flex", flexDirection: "column" }}
                          >
                            <CustomPaper
                              design={
                                !isCustomer
                                  ? classes.chatBgC
                                  : classes.chatBgUsr
                              }
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                }}
                              >
                                {/* <CustomText
                                  design={
                                    !isCustomer ? classes.usrMsg : classes.adMsg
                                  }
                                >
                                  Title:{" "}
                                </CustomText> */}

                                <CustomText
                                  design={
                                    !isCustomer ? classes.usrMsg : classes.adMsg
                                  }
                                  style={{ fontWeight: "bold" }}
                                >
                                  {contentSeven.Title}{" "}
                                </CustomText>
                              </div>

                              {Object.keys(contentSeven.Data).map((key) => (
                                <>
                                  <div
                                    style={{
                                      display: "flex",
                                      flexDirection: "row",
                                    }}
                                    key={key}
                                  >
                                    <CustomText
                                      design={
                                        !isCustomer
                                          ? classes.usrMsg
                                          : classes.adMsg
                                      }
                                    >
                                      {addSpacingToKey(key)}:{" "}
                                    </CustomText>

                                    <CustomText
                                      design={
                                        !isCustomer
                                          ? classes.usrMsg
                                          : classes.adMsg
                                      }
                                      style={{
                                        marginLeft: 20,
                                        fontWeight: "bold",
                                      }}
                                    >
                                      {contentSeven.Data[key]}
                                    </CustomText>
                                  </div>
                                </>
                              ))}

                              {/* <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                }}
                              >
                                <CustomText
                                  design={
                                    !isCustomer ? classes.usrMsg : classes.adMsg
                                  }
                                >
                                  Policy Number:{" "}
                                </CustomText>

                                <CustomText
                                  design={
                                    !isCustomer ? classes.usrMsg : classes.adMsg
                                  }
                                  style={{ marginLeft: 20, fontWeight: "bold" }}
                                >
                                  {contentSeven.Data.PolicyNumber}{" "}
                                </CustomText>
                              </div>

                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                }}
                              >
                                <CustomText
                                  design={
                                    !isCustomer ? classes.usrMsg : classes.adMsg
                                  }
                                >
                                  Product Name:{" "}
                                </CustomText>

                                <CustomText
                                  design={
                                    !isCustomer ? classes.usrMsg : classes.adMsg
                                  }
                                  style={{ marginLeft: 20, fontWeight: "bold" }}
                                >
                                  {contentSeven.Data.ProductName}{" "}
                                </CustomText>
                              </div>

                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                }}
                              >
                                <CustomText
                                  design={
                                    !isCustomer ? classes.usrMsg : classes.adMsg
                                  }
                                >
                                  Coverage Period:
                                </CustomText>

                                <CustomText
                                  design={
                                    !isCustomer ? classes.usrMsg : classes.adMsg
                                  }
                                  style={{ marginLeft: 20, fontWeight: "bold" }}
                                >
                                  {contentSeven.Data.CoveragePeriod}{" "}
                                </CustomText>
                              </div>

                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                }}
                              >
                                <CustomText
                                  design={
                                    !isCustomer ? classes.usrMsg : classes.adMsg
                                  }
                                >
                                  Premium:{" "}
                                </CustomText>

                                <CustomText
                                  design={
                                    !isCustomer ? classes.usrMsg : classes.adMsg
                                  }
                                  style={{ marginLeft: 20, fontWeight: "bold" }}
                                >
                                  {contentSeven.Data.Premium}{" "}
                                </CustomText>
                              </div> */}
                            </CustomPaper>
                          </div>
                        )}

                        {messageType !== 5 &&
                        messageType !== 6 &&
                        messageType !== 7 ? (
                          <CustomPaper
                            design={
                              !isCustomer ? classes.chatBgC : classes.chatBgUsr
                            }
                          >
                            <CustomText
                              design={
                                !isCustomer ? classes.usrMsg : classes.adMsg
                              }
                              dangerouslySetInnerHTML={{
                                __html:
                                  content.split("\n")[0] +
                                  `<br/>` +
                                  (content.split("\n")[1] !== undefined
                                    ? content.split("\n")[1] + `<br/>`
                                    : "") +
                                  (content.split("\n")[2] !== undefined
                                    ? content.split("\n")[2] + `<br/>`
                                    : "") +
                                  (content.split("\n")[3] !== undefined
                                    ? content.split("\n")[3] + `<br/>`
                                    : "") +
                                  (content.split("\n")[4] !== undefined
                                    ? content.split("\n")[4] + `<br/>`
                                    : "") +
                                  (content.split("\n")[5] !== undefined
                                    ? content.split("\n")[5] + `<br/>`
                                    : "") +
                                  (content.split("\n")[6] !== undefined
                                    ? content.split("\n")[6] + `<br/>`
                                    : "") +
                                  (content.split("\n")[7] !== undefined
                                    ? content.split("\n")[7] + `<br/>`
                                    : "") +
                                  (content.split("\n")[8] !== undefined
                                    ? content.split("\n")[8] + `<br/>`
                                    : "") +
                                  (content.split("\n")[9] !== undefined
                                    ? content.split("\n")[9] + `<br/>`
                                    : "") +
                                  (content.split("\n")[10] !== undefined
                                    ? content.split("\n")[10] + `<br/>`
                                    : ""),
                              }}
                            ></CustomText>
                            <Grid
                              container
                              spacing={1}
                              direction={"column"}
                              justify={!isCustomer ? "flex-start" : "flex-end"}
                            >
                              {!_.isEmpty(docList) && Array.isArray(docList)
                                ? docList.map((file, index) => {
                                    const docId = "test";
                                    const docName = "test";

                                    return (
                                      <CustomText
                                        key={index}
                                        design={classes.docNameTextStyle}
                                        onClick={() =>
                                          onClickFileAttached(docId)
                                        }
                                      >
                                        {docName}
                                      </CustomText>
                                    );
                                  })
                                : false}
                            </Grid>
                          </CustomPaper>
                        ) : (
                          false
                        )}

                        {messageType === 5 ? (
                          <CustomPaper
                            design={
                              !isCustomer ? classes.chatBgC : classes.chatBgUsr
                            }
                          >
                            <div
                              style={{
                                display: "flex",
                                flexDirection: "column",
                              }}
                            >
                              <div>
                                <img
                                  src={Image.scheduleApp}
                                  style={{ height: "24px" }}
                                />
                              </div>
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                }}
                              >
                                {" "}
                                <CustomText
                                  design={
                                    !isCustomer ? classes.usrMsg : classes.adMsg
                                  }
                                  dangerouslySetInnerHTML={{
                                    __html: content.split("|")[0],
                                  }}
                                ></CustomText>
                              </div>

                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                }}
                              >
                                {" "}
                                <div style={{ marginRight: 20 }}>
                                  Date:{" "}
                                  <CustomText
                                    design={
                                      !isCustomer
                                        ? classes.usrMsg
                                        : classes.adMsg
                                    }
                                    dangerouslySetInnerHTML={{
                                      __html: b,
                                    }}
                                  ></CustomText>
                                </div>
                                <div>
                                  Time slot:{" "}
                                  <CustomText
                                    design={
                                      !isCustomer
                                        ? classes.usrMsg
                                        : classes.adMsg
                                    }
                                    dangerouslySetInnerHTML={{
                                      __html: c,
                                    }}
                                  ></CustomText>
                                </div>
                              </div>
                            </div>
                          </CustomPaper>
                        ) : (
                          false
                        )}
                        {/*  */}
                        {sender === "Chatbot" && index > 1 && (
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              marginLeft: 15,
                              marginTop: 13,
                            }}
                          >
                            <img
                              src={
                                item.FeedbackStatus === false
                                  ? Image.bad2
                                  : Image.bad1
                              }
                              style={{
                                width: "16px",
                                cursor: "pointer",
                                border: "1px solid #777E90",
                                borderRadius: "44%",
                                padding: "5px",
                              }}
                              onClick={() => sendLikeButton(item.ChatId, 0)}
                            />{" "}
                            <img
                              src={
                                item.FeedbackStatus === true
                                  ? Image.good2
                                  : Image.good1
                              }
                              style={{
                                width: "16px",
                                marginLeft: 20,
                                cursor: "pointer",
                                border: "1px solid #777E90",
                                borderRadius: "44%",
                                padding: "5px",
                              }}
                              onClick={() => sendLikeButton(item.ChatId, 1)}
                            />
                          </div>
                        )}
                      </Grid>

                      <div ref={handleBottomRef} />
                    </div>
                  </div>
                );
              })
            : false}

          {histList.length <= 0 ? (
            <div style={{ paddingRight: 20, paddingLeft: 20 }}>
              <Grid
                container
                justify={"flex-start"}
                alignItems="center"
                style={{ flexWrap: "nowrap" }}
              >
                <img
                  src={Image.liveChatChatBot}
                  className={classes.imageLiveChatStyle}
                />
                <CustomPaper design={classes.chatBgC}>
                  <CustomText design={classes.usrMsg}>
                    Hello there, I am Chatbot Trix and I am happy to help you
                    today!
                  </CustomText>
                </CustomPaper>
              </Grid>
              <Grid
                container
                justify={"flex-start"}
                alignItems="center"
                style={{ marginTop: 40, flexWrap: "nowrap" }}
              >
                <img
                  src={Image.liveChatChatBot}
                  className={classes.imageLiveChatStyle}
                />
                <CustomPaper design={classes.chatBgC}>
                  <CustomText design={classes.usrMsg}>
                    Here are some common enquiries:
                  </CustomText>
                </CustomPaper>
              </Grid>
            </div>
          ) : (
            false
          )}

          {createChatBtns.length > 0 && histList.length > 0 && (
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                flexWrap: "wrap",
                // marginTop: 25,
                marginLeft: 25,
                // marginBottom: 20,
              }}
            >
              {createChatBtns.length > 0 &&
                createChatBtns.map((item, index) => {
                  return (
                    <div
                      style={{ marginBottom: 20, cursor: "pointer" }}
                      onClick={() =>
                        onClickSendMessage(
                          item.title,
                          item.payload,
                          item.type,
                          item.intent,
                          item.level
                        )
                      }
                      className={classes.threeSelect}
                    >
                      {item.title}
                    </div>
                  );
                })}
              {/* <div className={classes.threeSelect}>Policy Enquiry</div>
                  <div className={classes.threeSelect}>Claim Enquiry</div>
                  <div className={classes.threeSelect}>Speak to an agent</div> */}
            </div>
          )}
        </List>
      </Grid>
    </Grid>
  );
};

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {};
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(MessageList));
